import React from 'react'
import PropTypes from 'prop-types'
import HelpIcon from 'material-ui/svg-icons/action/help'
import FlatButton from 'material-ui/FlatButton'
import styles from './styles/HelpButton'

const CachedHelpIcon = <HelpIcon color={'grey'} hoverColor={'orange'} />

const HelpButton = ({ onTouchTap }) => (
  <div style={styles.helpIconContainer}>
    <FlatButton
      icon={CachedHelpIcon}
      onTouchTap={onTouchTap}
    />
  </div>
)

HelpButton.propTypes = {
  onTouchTap: PropTypes.func.isRequired,
}

export default HelpButton



// WEBPACK FOOTER //
// ./src/components/Settings/HelpButton.js